// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/auth/v1/auth.proto" (package "c1.api.auth.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Auth } from "./auth";
import type { GetRUMResponse } from "./auth";
import type { GetRUMRequest } from "./auth";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { IntrospectResponse } from "./auth";
import type { IntrospectRequest } from "./auth";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.auth.v1.Auth
 */
export interface IAuthClient {
    /**
     * Introspect returns the current user's principle_id, user_id and a list of roles, permissions, and enabled features.
     *
     * @generated from protobuf rpc: Introspect
     */
    introspect(input: IntrospectRequest, options?: RpcOptions): UnaryCall<IntrospectRequest, IntrospectResponse>;
    /**
     * @generated from protobuf rpc: GetRUM
     */
    getRUM(input: GetRUMRequest, options?: RpcOptions): UnaryCall<GetRUMRequest, GetRUMResponse>;
}
/**
 * @generated from protobuf service c1.api.auth.v1.Auth
 */
export class AuthClient implements IAuthClient, ServiceInfo {
    typeName = Auth.typeName;
    methods = Auth.methods;
    options = Auth.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Introspect returns the current user's principle_id, user_id and a list of roles, permissions, and enabled features.
     *
     * @generated from protobuf rpc: Introspect
     */
    introspect(input: IntrospectRequest, options?: RpcOptions): UnaryCall<IntrospectRequest, IntrospectResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<IntrospectRequest, IntrospectResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRUM
     */
    getRUM(input: GetRUMRequest, options?: RpcOptions): UnaryCall<GetRUMRequest, GetRUMResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRUMRequest, GetRUMResponse>("unary", this._transport, method, opt, input);
    }
}
